import { ThemeProvider } from '@mui/material/styles';
import AppRoute from './routes';
import theme from './theme';
import { TimerProvider } from './contexts/Timer/TimerProvider';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <TimerProvider>
            {/* <ToastContainer transition={Slide} {...toastOptions} /> */}
      <AppRoute />
      </TimerProvider>
  
    </ThemeProvider>
  );
}

export default App;
